import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';

import {TranslateModule} from '@ngx-translate/core';
import {NgxSpinnerModule} from 'ngx-spinner';

import {SharedModule} from '@atmi/shared';
import {UiModule} from '@ui/ui.module';

import {
  CollectionElementsComponent
} from '@sim/collections/components/collection-elements/collection-elements.component';
import {CollectionFiltersComponent} from './components/collection-filters/collection-filters.component';
import {CollectionItemsFiltersComponent} from './components/collection-items-filters/collection-items-filters.component';
import {CollectionItemsComponent} from './components/collection-items/collection-items.component';
import {CollectionManagerComponent} from './components/collection-manager/collection-manager.component';
import {CollectionsComponent} from './components/collections/collections.component';
import {CollectionPickerDialogComponent} from './dialogs/collection-picker-dialog/collection-picker-dialog.component';
import {CollectionModuleConfiguration} from './models/configuration';
import {CollectionApiService, CollectionItemApiService, UICollectionService} from './services';
import {CollectionConfigurationService} from './token';

import {DragDropModule} from '@angular/cdk/drag-drop';

export * from './components/collection-manager/collection-manager.component';
export * from './components/collections/collections.component';
export * from './models/configuration';
export * from './token';

const MATERIAL = [
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatCardModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatSelectModule,
  MatTabsModule,
];

const COMPONENTS = [
  CollectionFiltersComponent,
  CollectionItemsComponent,
  CollectionElementsComponent,
  CollectionItemsFiltersComponent,
  CollectionManagerComponent,
  CollectionsComponent,
];

const DIALOGS = [
  CollectionPickerDialogComponent,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIALOGS,
  ],
  exports: [
    ...COMPONENTS,
    ...DIALOGS,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    TranslateModule,
    NgxSpinnerModule,
    ...MATERIAL,
    MatTableModule,
    DragDropModule,
  ],
})
export class CollectionModule {
  static forRoot(config: CollectionModuleConfiguration): ModuleWithProviders<CollectionModule> {
    return {
      ngModule: CollectionModule,
      providers: [
        CollectionApiService,
        CollectionItemApiService,
        UICollectionService,
        {provide: CollectionConfigurationService, useValue: config},
      ],
    };
  }
}
